import React from 'react';
import aboutVideo from '../assets/video/about.mp4';
import aboutPoster from '../assets/img/111.jpg';

function About() {
  const identities = [
    {
      title: "Global Logistics Expert",
      description: "With extensive experience in international trade and logistics, we have mastered the intricacies of global supply chains.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: "Technology Innovator",
      description: "We leverage cutting-edge technology to provide real-time tracking, automated reporting, and AI-powered optimization.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      title: "Customer Success Partner",
      description: "We don't just move goods; we build partnerships focused on your success and growth in global markets.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905a3.61 3.61 0 01-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
        </svg>
      )
    }
  ];


  return (
    <section id="about" className="section-padding bg-black">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Content */}
          <div>
            <h2 className="heading-secondary mb-6">
              About <span className="text-red">Stargate</span><br></br>Shipping
            </h2>
            

            
            {/* Vision and Mission Statements */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-white mb-4">Vision</h3>
              <p className="text-lg text-gray-light mb-8 leading-relaxed italic">
                "To make every journey a bridge, connecting continents, ideas, and possibilities with precision, care, and purpose."
              </p>
              
              <h3 className="text-2xl font-bold text-white mb-4">Mission</h3>
              <p className="text-lg text-gray-light mb-8 leading-relaxed italic">
                "Fusing innovation with sustainability, turning logistics into a seamless experience that empowers businesses and respects the planet."
              </p>
            </div>
            
            {/* Identities */}
            <div className="space-y-6">
              {identities.map((identity, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-r from-red to-orange rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                    <div className="text-white">{identity.icon}</div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">{identity.title}</h3>
                    <p className="text-gray-light">{identity.description}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-10">
              <button
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="btn-primary px-8 py-4"
              >
                Connect With Us
              </button>
            </div>
          </div>
          
          {/* Video */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-red/20">
              <video 
                src={aboutVideo} 
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-96 object-cover rounded-2xl"
                poster={aboutPoster}
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;